import React from 'react'
import Layout from '../components/layout-global'
import Features from '../components/features'

const page = () => (
  <Layout centered>
    <Features />
  </Layout>
)

export default page
